<div class="neki-app">
	<router-outlet />
	<m-modal-container></m-modal-container>
	<m-notification-list class="neki-app__notification-list"></m-notification-list>
</div>
